import AxiosRequest from 'utils/AxiosRequest';
import config from 'configuration/configuration.js';

export const SESSION_LOGIN = 'SESSION_LOGIN';
export const SESSION_LOGOUT = 'SESSION_LOGOUT';
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const USER_INFO = 'USER_INFO';
export const SET_LOADING = 'SET_LOADING';
export const REDIRECT_TO_ERROR = 'REDIRECT_TO_ERROR';
export const SET_DOWNLOADS = 'SET_DOWNLOADS';

const onSetNotifications = (value) => ({
	type: SET_NOTIFICATIONS,
	notifications: value
});

const onLogin = () => ({
	type: SESSION_LOGIN,
});

const onGetUserInfo = (value) => ({
	type: USER_INFO,
	user: value
});

const onSetLoading = (value) => ({
	type: SET_LOADING,
	isLoading: value
});

const onRedirectToError = (value) => ({
	type: REDIRECT_TO_ERROR,
	link: value
});

const onSetDownloads = (downloads, downloadskey) => ({
	type: SET_DOWNLOADS,
	downloads,
	downloadskey
});

export const getUserInfo = (token) => async (dispatch) => {
	try {
		await AxiosRequest(
			{
				method: 'POST',
				url: `${config.API_URL}account/GetUserInfo`,
				headers: { Authorization: `Bearer ${token}` }
			}
		).then(response => {
			dispatch(onGetUserInfo(response.data));
		});
	} catch (error) {
		// do nothing
	}
};

export const login = (email, password) => async (dispatch) => {
	try {
		await AxiosRequest({
			method: 'POST',
			url: `${config.API_URL}auth/login`,
			data: { email, password }
		}).then(response => {
			localStorage.setItem(config.TOKEN_KEY, response.data.token);
			dispatch(onRedirectToError());
			dispatch(getUserInfo(response.data.token));
			dispatch(onLogin());
		});
	} catch (error) {
		throw new Error(error ? error.message : 'Network error!');
	}
};

export const logout = () => (dispatch) => {
	localStorage.removeItem(config.TOKEN_KEY);
	dispatch({
		type: SESSION_LOGOUT,
	});
};

export const RedirectToError = (link) => (dispatch) => {
	dispatch(onRedirectToError(link));
};

export const recover = (email) => async (dispatch) => {
	try {
		await AxiosRequest({
			method: 'POST',
			url: `${config.API_URL}auth/recover`,
			data: {
				email
			}
		}).then(response => response);
	} catch (error) {
		throw new Error(error ? error.message : 'Network error!');
	}
};

export const CompleteRegistration = (password, rpassword, token, email) => async (dispatch) => {
	try {
		await AxiosRequest({
			method: 'POST',
			url: `${config.API_URL}auth/completeRegistration`,
			data: {
				password,
				rpassword,
				token,
				user: email
			}
		}).then(response => {
			localStorage.setItem(config.TOKEN_KEY, response.data.token);
			dispatch(onLogin());
			dispatch(getUserInfo(response.data.token));
		});
	} catch (error) {
		throw new Error(error ? error.message : 'Network error!');
	}
};

export const ResetPassword = (password, rpassword, token, email) => async (dispatch) => {
	try {
		await AxiosRequest({
			method: 'POST',
			url: `${config.API_URL}auth/recoverconfirmation`,
			data: {
				password,
				rpassword,
				token,
				user: email
			}
		}).then(response => {
			localStorage.setItem(config.TOKEN_KEY, response.data.token);
			dispatch(onLogin());
			dispatch(getUserInfo(response.data.token));
		});
	} catch (error) {
		throw new Error(error ? error.message : 'Network error!');
	}
};

export const FetchNotifications = () => async (dispatch) => {
	try {
		await AxiosRequest(
			{
				method: 'GET',
				url: `${config.API_URL}Notification/Notifications`,
				hasLoading: false
			}
		).then(response => {
			dispatch(onSetNotifications(response.data));
		});
	} catch (error) {
		// do nothing
	}
};

export const FetchDownloads = (userId, key) => async (dispatch) => {
	try {
		await AxiosRequest(
			{
				method: 'GET',
				url: `${config.API_URL}File/GetDownloads`,
				params: { userId, key },
				hasLoading: false
			}
		).then(response => {
			dispatch(onSetDownloads(response.data, key));
		});
	} catch (error) {
		// do nothing
	}
};

export const NotificationMarkAsRead = (id) => async (dispatch) => {
	try {
		await AxiosRequest(
			{
				method: 'PUT',
				url: `${config.API_URL}Notification/MarkAsRead/${id}`,
				hasLoading: false
			}
		).then(response => {
			dispatch(FetchNotifications());
		});
	} catch (error) {
		// do nothing
	}
};

export const SetLoading = (isLoading) => dispatch => {
	dispatch(onSetLoading(isLoading));
};

export const UploadFile = (file) => {
	const formData = new FormData();
	formData.append('file', file);
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}File/Upload`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

export const UploadMultipleFiles = (files) => {
	const formData = new FormData();
	files.forEach(file => {
		if (!file.size < 10000000) {
			formData.append('file', file);
		}
	});
	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}File/UploadMultiple`,
		data: formData,
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
};

const ShowFile = (response) => {
	const blob = response.data;
	const filename = decodeURIComponent(response.headers['content-disposition'].split('\'')[2]);
	// It is necessary to create a new blob object with mime-type
	// explicitly set otherwise only Chrome works like it should
	const newBlob = new Blob([blob], { type: 'application/force-download' });

	// IE doesn't allow using a blob object directly as link href
	// instead it is necessary to use msSaveOrOpenBlob
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		window.navigator.msSaveOrOpenBlob(newBlob);
		return;
	}

	// For other browsers:
	// Create a link pointing to the ObjectURL containing the blob.
	const data = window.URL.createObjectURL(newBlob);
	const link = document.createElement('a');
	link.href = data;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	setTimeout(() => {
		// For Firefox it is necessary to delay revoking the ObjectURL
		document.body.removeChild(link);
		window.URL.revokeObjectURL(data);
	}, 100);
};

export const DownloadFile = (filePath) => async dispatch => {
	try {
		await AxiosRequest(
			{
				method: 'GET',
				url: `${config.API_URL}File/Download?file=${filePath}`,
				responseType: 'blob'
			}
		).then(response => {
			ShowFile(response);
		});
	} catch (error) {
		// do nothing
	}
};
